"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag3dEngine = void 0;
const Tag3dEngine_1 = require("./Tag3dEngine");
Object.defineProperty(exports, "Tag3dEngine", { enumerable: true, get: function () { return Tag3dEngine_1.Tag3dEngine; } });
//# sourceMappingURL=index.js.map